
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Field',
  props: {
    editing: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    return { props }
  }
})
